module.exports = __webpack_public_path__ + "35df2f096605ecff8883cf1195968c44.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/fam/american_funds.png
// module id = 1409
// module chunks = 0